import React, {useCallback, useMemo, useState} from 'react';
import styled, {useTheme} from "styled-components";
import SllTierRunExplain from "./SllTierRunExplain";
import {ColumnBox, FlexBox, MarginBox} from "../../ui/styled";
import SmallInfluInfo from "../../common/SmallInfluInfo";
import SllTierRunGraphSvg from "./SllTierRunGraphSvg";
import EmblemImage from "../../EmblemImage";
import TierTag from "../../common/TierTag";
import GradientScoreBox from "../../common/GradientScoreBox/GradientScoreBox";
import ChampionsWhiteWrapper from "../../Champions/ChampionsContent/ChampionsWhiteWrapper";
import RankingTableHeader
    from "../../Champions/ChampionsContent/ChampionsRank/ChampionsRankingTable/RankingTableHeader";
import {getTierScore, romanNumberConverter, sortChampData, threedigits} from "../../../function";
import ToSummonerLink from "../../Link/ToSummonerLink";
import useSortArray from "../../../common/hooks/useSortArray";
import RankingTableNavigator from "../../Ranking/RankingContent/RankingTable/RankingTableContent/RankingTableNavigator";
import useTimeHook from "../../../common/hooks/useTimeHook";

const SelectorItemWrapper = styled.button`
  opacity: ${props => {
    let opacity = '0.5';
    if (props.selected) {
      opacity = '1'
    }
    return opacity
  }};
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: row;
  border-radius: 5px 5px 0 0;
  border: 1px solid ${props => {
    let color = '#5970FF'
    if (props.value === 'CHALLENGE') {
      color = '#5970FF'
    } else if (props.value === 'EXPERT') {
      color = '#ACE39B'
    } else if (props.value === 'POTENTIAL') {
      color = '#60A4AA'
    }
    return color
  }};
  border-bottom: 0;
  align-items: center;
  justify-content: flex-start;
  height: 45px;
  padding: 10px;
  background-color: ${props => {
    let background = 'transparent';
    if (props.selected) {
      background = props.theme.color.white_201
    }
    return background
  }};

  &:hover {
    background-color: ${props => {
      let background = props.theme.color.white_200
      if (props.selected) background = props.theme.color.white_201
      return background
    }};
  }

  & + & {
    margin-left: 8px;
  }
`;

const AbsoluteBox = styled.div`
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: ${props => props.theme.color.white_201};
`;
const Wrapper = styled.div`
  width: 688px;
`;
const CategoryBox = styled.div`
  display: flex;
  flex-direction: row;
`;
const SelectedGreenBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 5px;
  background-color: ${props => {
    let color = '#5970FF'
    if (props.value === 'CHALLENGE') {
      color = '#5970FF'
    } else if (props.value === 'EXPERT') {
      color = '#ACE39B'
    } else if (props.value === 'POTENTIAL') {
      color = '#60A4AA'
    }
    return color;
  }};
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
`;
const ContentBox = styled.div`
  padding: 16px 12px;
  border-radius: 0 8px 8px 8px;
  border: 1px solid ${props => {
    let color = '#5970FF'
    if (props.cateogry === 'CHALLENGE') {
      color = '#5970FF'
    } else if (props.cateogry === 'EXPERT') {
      color = '#ACE39B'
    } else if (props.cateogry === 'POTENTIAL') {
      color = '#60A4AA'
    }
    return color;
  }};
  background-color: ${props => props.theme.color.white_201};
`;
const TitleBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
const CardBox = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  gap: 15px;
`;
const TableBox = styled.div`
  margin-top: 32px;

  .filter-arrow {
    margin-left: 4px;
  }
`;


const TitleText = styled.span`
  font-family: Pretendard;
  font-weight: 600;
  font-size: 24px;
  line-height: 100%;
  color: ${props => props.theme.color.dark_100};
`;
const TitleGreenText = styled.span`
  color: ${props => props.theme.color.green_100};
`;

const SubTitle = styled.span`
  font-family: Pretendard;
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  color: ${props => props.theme.color.dark_200};
`;
const SllTierRunInfo = ({data, scoreData}) => {
    const [category, setCategory] = useState('CHALLENGE');
    const [currentPage, setCurrentPage] = useState(1);

    const onChangeCategory = useCallback((value) => {
        setCategory(value)
        setCurrentPage(1)
    },[])

    const list = useMemo(() => {
        try {
            let list = [];
            if (category === 'CHALLENGE') {
                list = data.Challenge
            } else if (category === 'EXPERT') {
                list = data.Expert
            } else if (category === 'POTENTIAL') {
                list = data.Potential
            }
            return list.map((data, index) => {
                return {
                    ...data,
                    rank: index + 1,
                    current_tier_value: getTierScore(data.current_tier).num + data.current_lp,
                    goal_tier_value: getTierScore(data.goal_tier).num + data.goal_lp,
                }
            })
        } catch (e) {
            return [];
        }
    }, [data, category]);
    const runCardContent = useMemo(() => {
        try {
            const runCardSort = [{
                value: "need_lp",
                sortType: true
            },];
            const sortedList = sortChampData(list, runCardSort);
            return sortedList.slice(0, 3);
        } catch (e) {
            return []
        }
    }, [list]);
    const mainContentList = useMemo(() => {
        try {
            return list.slice(3);
        } catch (e) {
            return []
        }
    }, [list]);


    const graphBoxScore = useMemo(() => {
        try {
            let score = 0;
            if (category === 'CHALLENGE') {
                score = scoreData.Challenge
            } else if (category === 'EXPERT') {
                score = scoreData.Expert
            } else if (category === 'POTENTIAL') {
                score = scoreData.Potential
            }
            return score
        } catch (e) {
            return 0
        }
    }, [scoreData, category]);

    return (
        <Wrapper>
            <CategoryBox>
                <SllTierRunCategory selected={category} setCategory={onChangeCategory} value={'CHALLENGE'}/>
                <SllTierRunCategory selected={category} setCategory={onChangeCategory} value={'EXPERT'}/>
                <SllTierRunCategory selected={category} setCategory={onChangeCategory} value={'POTENTIAL'}/>
            </CategoryBox>
            <ContentBox cateogry={category}>
                <TitleBox>
                    <div>
                        <div>
                            <TitleText>
                                {category} <TitleGreenText>TOP3</TitleGreenText> </TitleText>
                        </div>
                        <ColumnBox>
                            <SubTitle>현재 {category}의 실시간 TOP3를 확인해 보세요.</SubTitle>
                            {category === 'CHALLENGE' && <SubTitle>동률인 경우 게임수가 적은 유저,승률이 높은 유저 순으로 집계됩니다.</SubTitle>}
                            {category === 'EXPERT' &&
                                <SubTitle>정규 경기수(50 경기)를 채운 유저 중 목표 티어를 먼저 달성한 유저 순으로 집계됩니다.</SubTitle>}
                            {category === 'POTENTIAL' &&
                                <SubTitle>정규 경기수(50 경기)를 채운 유저 중 목표 티어를 먼저 달성한 유저 순으로 집계됩니다.</SubTitle>}
                        </ColumnBox>
                    </div>
                    <div>
                        <SllTierRunExplain category={category}/>
                    </div>
                </TitleBox>
                <CardBox>
                    <SllTierRunCard data={runCardContent?.[0]} place={'first'} graphBoxScore={graphBoxScore}/>
                    <SllTierRunCard data={runCardContent?.[1]} place={'second'} graphBoxScore={graphBoxScore}/>
                    <SllTierRunCard data={runCardContent?.[2]} place={'third'} graphBoxScore={graphBoxScore}/>
                </CardBox>
                {mainContentList.length > 0 &&
                    <TableBox>
                        <SllTierTable list={mainContentList} currentPage={currentPage} setCurrentPage={setCurrentPage}/>
                    </TableBox>}
            </ContentBox>
        </Wrapper>
    );
};

const TableHeaderText = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: Pretendard;
  font-weight: 500;
  font-size: 10px;
  line-height: 100%;
  color: ${props => props.theme.color.dark_200};
`;
const TableContent = styled.td`
  vertical-align: middle;

  .imgDiv {
    border-radius: 4px;
  }

  .imgChamp {
    width: 38px;
    height: 38px;
  }
`;

const RankText = styled.span`
  font-family: Pretendard;
  font-weight: 600;
  font-size: 12px;
  line-height: 100%;
  color: ${props => props.theme.color.dark_100};
`;

const RankGreenBox = styled.div`
  font-family: Pretendard;
  font-weight: 600;
  font-size: 14px;
  line-height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const ProIconBox = styled.div`
  margin-left: 10px;
  margin-right: 4px;
`;

const ProNameBox = styled.div`
  &:hover {
    text-decoration: underline;
  }

  font-family: Pretendard;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  color: ${props => props.theme.color.dark_200};
  width: 125px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const TablePercent = styled.div`
  font-family: Pretendard;
  font-weight: 500;
  font-size: 10px;
  line-height: 100%;
  color: ${props => props.theme.color.dark_200};
`;

const TableLpText = styled.div`
  font-family: Pretendard;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  color: ${props => props.theme.color.dark_200};
`;
const TierBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 4px;
  margin-right: 2px;
`;
const TableLpBigText = styled.div`
  font-family: Pretendard;
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  color: ${props => props.theme.color.white_400};
`;
const TableGreenLpText = styled.div`
  font-family: Pretendard;
  font-weight: 600;
  font-size: 14px;
  line-height: 100%;

  color: ${props => props.theme.color.green_100};
`;
const ContentTr = styled.tr`
  height: 56px;

  &.light + &.light {
    border-top: 1px solid ${props => props.theme.color.default_border_color};
  }

  &.dark + &.dark {
    border-top: 1px solid ${props => props.theme.color.default_border_color};
  }
`;

const HeaderTr = styled.tr`
  background-color: ${props => props.theme.color.white_201};
  border-bottom: 1px solid ${props => props.theme.color.default_border_color};
`;

const initSort = [{
    value: 'rank',
    sortType: false,
    reverseSort: true
}];

const initSortList = {
    rank: {
        value: 'rank',
        sortType: false,
        reverseSort: true
    },
    current_tier_value: {
        value: 'current_tier_value',
        sortType: false,
    },
    goal_tier_value: {
        value: 'goal_tier_value',
        sortType: false,
    },
    need_lp: {
        value: 'need_lp',
        sortType: false,
        reverseSort: true,
    },
    matches: {
        value: 'matches',
        sortType: false,
    },
    ai_score: {
        value: 'ai_score',
        sortType: true,
    },
}
const SllTierTableWrapper = styled.div`
  .navigator-wrapper {
    margin-top: 32px;
  }
`;

const PAGE_COUNT = 25
const SllTierTable = ({list,currentPage,setCurrentPage}) => {

    const theme = useTheme();
    const {sort, sortList, onClickSort} = useSortArray({
        initSort: initSort,
        initSortList: initSortList,
    });
    const sortedList = useMemo(() => {
        try {
            return sortChampData(list, sort)
        } catch (e) {
            return []
        }
    }, [sort, list]);

    const lastPage = useMemo(() => Math.ceil(sortedList.length / PAGE_COUNT), [list]);


    const calcFirstIndex = () => {
        return ((currentPage - 1) * PAGE_COUNT);
    }
    const calcLastIndex = () => {
        return (currentPage * PAGE_COUNT - 1)
    }

    const onClickGoToPage = (value) => {
        if (currentPage !== value) {
            setCurrentPage(value);
        }
    }

    const onClickToEnd = () => {
        if (currentPage !== lastPage) {
            setCurrentPage(lastPage)
        }
    }
    const onClickToFist = () => {
        if (currentPage !== 1) {
            setCurrentPage(1)
        }

    }
    const onClickPrev = () => {
        if (currentPage > 1) {
            setCurrentPage(prev => prev - 1);
        }
    }
    const onClickNext = () => {
        if (currentPage < lastPage) {
            setCurrentPage(prev => prev + 1);
        }
    }


    const filteredList = useMemo(() => {
        // 1 - 1 * 100  ~ 1 * 100 - 1
        // 2 - 1 * 100  ~ 2 * 100 -1
        // 3 - 1 * 100  ~ 3 * 100 -1

        const filter = sortedList.filter((_, index) => {
            return calcFirstIndex() <= index && index <= calcLastIndex()
        })
        return filter;

    }, [sortedList, currentPage]);
    const getSplitTier = (data) => {
        try {
            const splitTier = data.split(' ');
            if (splitTier.length < 2) {
                return {
                    tier: splitTier[0],
                    division: '',
                }
            }

            return {
                tier: splitTier[0],
                division: romanNumberConverter(splitTier[1])
            }
        } catch (e) {
            return {
                tier: 'Unranked',
                division: '',
            }
        }
    }
    return (
        <SllTierTableWrapper>
            <ChampionsWhiteWrapper>
                <table>
                    <thead>
                    <HeaderTr>
                        <RankingTableHeader
                            currentSort={sort}
                            onClickSort={onClickSort}
                            sort={sortList.rank}
                        >
                            <TableHeaderText>
                                순위
                            </TableHeaderText>
                        </RankingTableHeader>
                        <RankingTableHeader
                            disableBar={true}
                        >
                            <TableHeaderText>
                                스트리머 명
                            </TableHeaderText>
                        </RankingTableHeader>
                        <RankingTableHeader
                            disableBar={true}
                        >
                            <TableHeaderText>
                                승률
                            </TableHeaderText>
                        </RankingTableHeader>
                        <RankingTableHeader
                            currentSort={sort}
                            onClickSort={onClickSort}
                            sort={sortList.current_tier_value}
                        >
                            <TableHeaderText>
                                현재 티어
                            </TableHeaderText>
                        </RankingTableHeader>
                        <RankingTableHeader
                            currentSort={sort}
                            onClickSort={onClickSort}
                            sort={sortList.goal_tier_value}
                        >
                            <TableHeaderText>
                                목표 티어
                            </TableHeaderText>
                        </RankingTableHeader>
                        <RankingTableHeader
                            currentSort={sort}
                            onClickSort={onClickSort}
                            sort={sortList.need_lp}
                        >
                            <TableHeaderText>
                                <img src={`images/sll/icon_flame.svg`} alt={''} width={18} height={18}/>
                                남은 LP
                            </TableHeaderText>
                        </RankingTableHeader>
                        <RankingTableHeader
                            currentSort={sort}
                            onClickSort={onClickSort}
                            sort={sortList.matches}
                        >
                            <TableHeaderText>
                                경기 수
                            </TableHeaderText>
                        </RankingTableHeader>
                        <RankingTableHeader
                            currentSort={sort}
                            onClickSort={onClickSort}
                            sort={sortList.ai_score}
                        >
                            <TableHeaderText>
                                AI Score
                            </TableHeaderText>
                        </RankingTableHeader>

                    </HeaderTr>
                    </thead>
                    <tbody>
                    {filteredList.map((data, index) => {
                        const currentSplitTier = getSplitTier(data.current_tier)
                        const goalSplitTier = getSplitTier(data.goal_tier)
                        return (
                            <ContentTr key={data.name} className={theme.color.theme}>
                                <TableContent>
                                    <FlexBox height={'auto'} width={'43px'} justifyContent={'center'}>
                                        <RankText>
                                            {data.rank}
                                        </RankText>
                                    </FlexBox>
                                </TableContent>
                                <TableContent>
                                    <FlexBox height={'auto'} width={'208px'}>
                                        <PlayerImage
                                            src={`https://ak-deeplol-ddragon-cdn.deeplol.gg/${data.status.toLowerCase()}/${data.name}.png`}
                                            width={32}
                                            height={32}
                                            alt={''}
                                            onError={(e) => e.target.src = '/images/sll/sll_empty_profile.svg'}
                                        />
                                        <ProIconBox>
                                            <SmallInfluInfo status={data.status}/>
                                        </ProIconBox>
                                        <ToSummonerLink name={`${data.riot_id_name}-${data.riot_id_tag_line}`}
                                                        region={'KR'}
                                                        puu_id={data.puu_id}>
                                            <ProNameBox>
                                                {data.name}
                                            </ProNameBox>
                                        </ToSummonerLink>
                                    </FlexBox>
                                </TableContent>
                                <TableContent>
                                    <FlexBox height={'auto'} width={'48px'} justifyContent={'center'}
                                             alignItems={'flex-end'}>
                                        <RankText>
                                            {(data.win_per * 100).toFixed(1)}
                                        </RankText>
                                        <TablePercent>
                                            %
                                        </TablePercent>
                                    </FlexBox>
                                </TableContent>
                                <TableContent>
                                    <FlexBox height={'auto'} width={'80px'} justifyContent={'center'}>
                                        <TierTag tier={currentSplitTier.tier} division={currentSplitTier.division}/>
                                        <TierBox>
                                            <RankText>
                                                {data.current_lp}
                                            </RankText>
                                        </TierBox>
                                        <TableLpText>
                                            LP
                                        </TableLpText>
                                    </FlexBox>
                                </TableContent>
                                <TableContent>
                                    <FlexBox height={'auto'} width={'80px'} justifyContent={'center'}>
                                        <TierTag tier={goalSplitTier.tier} division={goalSplitTier.division}/>
                                        <TierBox>
                                            <RankText>
                                                {data.goal_lp}
                                            </RankText>
                                        </TierBox>
                                        <TableLpText>
                                            LP
                                        </TableLpText>
                                    </FlexBox>
                                </TableContent>
                                <TableContent>
                                    {data.is_reached ?
                                        <FlexBox height={'auto'} width={'80px'} justifyContent={'center'}>
                                            <img src={`images/sll/icon_flame.svg`} alt={''} width={16} height={16}/>
                                            <TableGreenLpText>
                                                완주
                                            </TableGreenLpText>
                                        </FlexBox>
                                        :
                                        <FlexBox height={'auto'} width={'80px'} justifyContent={'center'}>
                                            <TableLpBigText>
                                                {threedigits(data.need_lp)}
                                            </TableLpBigText>
                                        </FlexBox>
                                    }
                                </TableContent>
                                <TableContent>
                                    <FlexBox height={'auto'} width={'48px'} justifyContent={'center'}>
                                        <RankText>
                                            {data.matches}
                                        </RankText>
                                    </FlexBox>
                                </TableContent>
                                <TableContent>
                                    <FlexBox height={'auto'} width={'77px'} justifyContent={'center'}>
                                        <GradientScoreBox width={'48px'} height={'30px'} fontSize={'18px'}
                                                          borderRadius={'6px'}>
                                            {data.ai_score}
                                        </GradientScoreBox>
                                    </FlexBox>
                                </TableContent>
                            </ContentTr>
                        )
                    })}
                    </tbody>
                </table>

            </ChampionsWhiteWrapper>
            <RankingTableNavigator
                onClickGoToPage={onClickGoToPage}
                onClickToEnd={onClickToEnd}
                onClickToFist={onClickToFist}
                onClickPrev={onClickPrev}
                onClickNext={onClickNext}
                currentPage={currentPage}
                lastPage={lastPage}
            />
        </SllTierTableWrapper>
    )
}

const SllTierRunCardWrapper = styled.div`
  position: relative;
  width: 211px;
  padding: 16px 12px;
  border-radius: 6px;
  border: 1px solid ${props => props.theme.color.default_border_color};
  background: ${props => props.theme.color.site_main_color};

  .imgChamp {
    width: 40px;
    aspect-ratio: 1;
  }

  .imgDiv {
    border-radius: 4px;
  }
`;


const NameText = styled.div`
  width: 83px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: Pretendard;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  color: ${props => props.theme.color.dark_100};

  &:hover {
    text-decoration: underline;
  }
`;

const RunCardGreenText = styled.div`
  font-family: Pretendard;
  font-weight: 700;
  font-size: 14px;
  line-height: 100%;
  color: ${props => props.theme.color.green_100};
  margin: 0 4px;
`;

const GamesText = styled.div`
  height: 12px;
  font-family: Pretendard;
  font-weight: 700;
  font-size: 10px;
  line-height: 100%;
  text-align: center;
  color: ${props => props.theme.color.dark_200};
`;
const LeftGreenText = styled.div`
  height: 1px;
  background: linear-gradient(90deg, rgba(83, 198, 170, 0) 0%, #53C6AA 100%);
  width: 16px;
`;
const RightGreenText = styled.div`
  height: 1px;
  background: linear-gradient(270deg, rgba(83, 198, 170, 0) 0%, #53C6AA 100%);
  width: 16px;
`;
const SllTierRunCardBigText = styled.div`
  font-family: Pretendard;
  font-weight: 700;
  font-size: 32px;
  line-height: 100%;
  color: ${props => props.theme.color.dark_100};
`;
const LPText = styled.span`
  font-family: Pretendard;
  font-weight: 600;
  font-size: 18px;
  line-height: 100%;
  color: ${props => props.theme.color.dark_200};
  margin-left: 4px;
`;
const TierRunCardAbsoluteBox = styled.div`
  position: absolute;
  top: 3px;
  right: 7px;
`;
const TierRunCardRelativeBox = styled.div`
  position: relative;
`;
const TierRunCardCircleBox = styled.div`
  width: 24px;
  height: 24px;
  border: 2px solid ${props => props.theme.color.green_100};
  border-radius: 100%;
  background: ${props => props.theme.color.site_main_color};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  padding-bottom: 1px;
`;
const CircleAbsoluteBox = styled.div`
  position: absolute;
  left: ${props => props.value}%;
  transform: translateX(-50%);
`;
const TierRunCardCircleRelativeBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
`;
const TierRunCardBar = styled.div`
  height: 1px;
  background: ${props => props.theme.color.default_border_color};
  width: 184px;
  margin: 16px 0;
`;
const TierRunFinishedCardBar = styled.div`
  height: 1px;
  background: ${props => props.theme.color.default_border_color};
  width: 184px;
  margin: 12px 0;
`;
const CardInfoBox = styled.div`
  padding: 6px;
  border-radius: 6px;
  background-color: ${props => props.theme.color.white_201};
`;
const CardInfoTierBox = styled.div`
  width: 74px;
`;
const CardInfoGreenText = styled.div`
  font-family: Pretendard;
  margin-bottom: 4px;
  font-weight: 500;
  font-size: 10px;
  line-height: 100%;
  text-align: center;
  color: ${props => props.theme.color.green_100};
  height: 12px;
`;

const CardFinishedGreenText = styled.div`
  font-family: Pretendard;
  font-weight: 500;
  font-size: 10px;
  line-height: 100%;
  text-align: center;
  color: ${props => props.theme.color.green_100};
  height: 12px;
`;

const LpText = styled.div`
  font-family: Pretendard;
  font-weight: 600;
  font-size: 12px;
  line-height: 100%;
  color: ${props => props.theme.color.dark_100};
  margin-left: 4px;
`;

const TimeText = styled.div`
  height: 11px;
  font-family: Pretendard;
  font-weight: 400;
  font-size: 10px;
  line-height: 100%;
  text-align: center;
  color: ${props => props.theme.color.dark_200};
  margin-bottom: 4px;
`;
const LpGrayText = styled.div`
  font-family: Pretendard;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  color: ${props => props.theme.color.dark_200};
  margin-left: 2px;
`;

const LpBar = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${props => props.theme.color.default_border_color};
  margin: 8px 0;
`;

const CardWinText = styled.div`
  margin-right: 4px;
  font-family: Pretendard;
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  color: ${props => props.theme.color.dark_100};
`;

const WinRateText = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  font-family: Pretendard;
  font-weight: 600;
  font-size: 18px;
  line-height: 100%;
  color: ${props => props.theme.color.blue_100};
`;

const PercentText = styled.div`
  margin-left: 2px;
  font-family: Pretendard;
  font-weight: 500;
  font-size: 10px;
  line-height: 100%;
  color: ${props => props.theme.color.dark_200};
`;

const AiText = styled.div`
  margin-right: 8px;
  font-family: Pretendard;
  font-weight: 500;
  font-size: 10px;
  line-height: 100%;
  text-align: center;
  vertical-align: middle;
  color: ${props => props.theme.color.dark_200};
`;

const RankBox = styled.div`
  position: absolute;
  right: 8px;
  top: 0;
`;


const PlayerImage = styled.img`
  border-radius: 4px;
  object-fit: cover;
`;

const SllTierRunCard = ({data, place, graphBoxScore, category}) => {
    const {lessMinWithIntl} = useTimeHook();

    const graphValue = useMemo(() => {
        try {
            const boxCount = 8;
            const graphResult = boxCount * graphBoxScore
            const resultValue = Number((((graphResult - data.need_lp) / graphResult) * 100).toFixed(0));
            if (resultValue < 0) {
                return 0
            }
            if (resultValue > 100) {
                return 100
            }
            return Number(resultValue)
        } catch (e) {
            return 0
        }
    }, [data?.goal_lp, data?.current_lp, graphBoxScore]);

    const currentSplitTier = useMemo(() => {
        try {
            const splitTier = data.current_tier.split(' ');
            if (splitTier.length < 2) {
                return {
                    tier: splitTier[0],
                    division: '',
                }
            }

            return {
                tier: splitTier[0],
                division: romanNumberConverter(splitTier[1])
            }
        } catch (e) {
            return {
                tier: 'Unranked',
                division: '',
            }
        }
    }, [data?.current_tier]);

    const goalSplitTier = useMemo(() => {
        try {
            const splitTier = data.goal_tier.split(' ');
            if (splitTier.length < 2) {
                return {
                    tier: splitTier[0],
                    division: '',
                }
            }

            return {
                tier: splitTier[0],
                division: romanNumberConverter(splitTier[1])
            }
        } catch (e) {
            return {
                tier: 'Unranked',
                division: '',
            }
        }
    }, [data?.goal_tier]);


    if (!data) {
        return null
    }


    if (data.is_reached && category !== 'CHALLENGE') {
        return (
            <SllTierRunCardWrapper>
                <RankBox>
                    <img src={`images/sll/img_sll_tier_${place}.svg`} alt={''} width={30} height={69}/>
                </RankBox>
                <div>
                    <FlexBox margin={'0 0 20px 0'}>
                        <PlayerImage
                            src={`https://ak-deeplol-ddragon-cdn.deeplol.gg/${data.status.toLowerCase()}/${data.name}.png`}
                            width={34}
                            height={34}
                            alt={''}
                            onError={(e) => e.target.src = '/images/sll/sll_empty_profile.svg'}
                        />
                        <MarginBox margin={'0 0 0 8px'}>
                            <SmallInfluInfo status={data.status} width={16} height={16}/>
                        </MarginBox>
                        <MarginBox margin={'0 0 0 4px'}>
                            <ToSummonerLink name={`${data.riot_id_name}-${data.riot_id_tag_line}`} region={'KR'}
                                            puu_id={data.puu_id}>
                                <NameText>
                                    {data.name}
                                </NameText>
                            </ToSummonerLink>
                        </MarginBox>
                    </FlexBox>
                    <FlexBox justifyContent={'center'}>
                        <LeftGreenText/>
                        <RunCardGreenText>
                            Tier Run
                        </RunCardGreenText>
                        <RightGreenText/>
                    </FlexBox>
                    <GamesText>
                        {data.matches} Games
                    </GamesText>
                    <FlexBox justifyContent={'center'} margin={'8px 0 0 0'}>
                        <SllTierRunCardBigText>
                            <span>CLEARED</span>
                        </SllTierRunCardBigText>
                    </FlexBox>
                    <FlexBox margin={'9px 0 0 0'}>
                        <TierRunCardRelativeBox>
                            <img src={`images/sll/img_sll_tier_run_graph_wrapper.svg`} alt={''} width={184}
                                 height={12}/>
                            <TierRunCardAbsoluteBox>
                                <TierRunCardCircleRelativeBox>
                                    <SllTierRunGraphSvg value={graphValue} place={place}/>
                                    <CircleAbsoluteBox value={graphValue}>
                                        <TierRunCardCircleBox>
                                            <EmblemImage width={16} height={16} tier={data.current_tier}/>
                                        </TierRunCardCircleBox>
                                    </CircleAbsoluteBox>
                                </TierRunCardCircleRelativeBox>
                            </TierRunCardAbsoluteBox>
                        </TierRunCardRelativeBox>
                    </FlexBox>
                    <TierRunFinishedCardBar/>
                    <CardInfoBox>
                        <FlexBox height={'auto'} justifyContent={'center'}>
                            <div>
                                <CardFinishedGreenText>
                                    COMPLETED
                                </CardFinishedGreenText>
                                <TimeText>
                                    <FinishedTime timeStamp={data.reached_at}/>
                                </TimeText>
                                <FlexBox height={'auto'} justifyContent={'center'}>
                                    <TierTag
                                        division={currentSplitTier.division}
                                        tier={currentSplitTier.tier}
                                    />
                                    <LpText>
                                        {data.goal_lp}
                                    </LpText>
                                    <LpGrayText>
                                        LP
                                    </LpGrayText>
                                </FlexBox>
                            </div>
                        </FlexBox>
                        <LpBar/>
                        <FlexBox height={'auto'} justifyContent={'space-between'}>
                            <FlexBox height={'auto'}>
                                <CardWinText>
                                    승률
                                </CardWinText>
                                <WinRateText>
                                    {(data.win_per * 100).toFixed(1)}
                                    <PercentText>
                                        %
                                    </PercentText>
                                </WinRateText>
                            </FlexBox>
                            <FlexBox height={'auto'}>
                                <AiText>
                                    AI-Score
                                </AiText>
                                <GradientScoreBox fontSize={'16px'} width={'40px'} height={'24px'} borderRadius={'4px'}>
                                    {data.ai_score}
                                </GradientScoreBox>
                            </FlexBox>
                        </FlexBox>
                    </CardInfoBox>
                </div>
            </SllTierRunCardWrapper>
        )
    }

    return (
        <SllTierRunCardWrapper>
            <RankBox>
                <img src={`images/sll/img_sll_tier_${place}.svg`} alt={''} width={30} height={69}/>
            </RankBox>
            <div>
                <FlexBox margin={'0 0 20px 0'}>
                    <PlayerImage
                        src={`https://ak-deeplol-ddragon-cdn.deeplol.gg/${data.status.toLowerCase()}/${data.name}.png`}
                        width={34}
                        height={34}
                        alt={''}
                        onError={(e) => e.target.src = '/images/sll/sll_empty_profile.svg'}
                    />
                    <MarginBox margin={'0 0 0 8px'}>
                        <SmallInfluInfo status={data.status} width={16} height={16}/>
                    </MarginBox>
                    <MarginBox margin={'0 0 0 4px'}>
                        <ToSummonerLink name={`${data.riot_id_name}-${data.riot_id_tag_line}`} region={'KR'}
                                        puu_id={data.puu_id}>
                            <NameText>
                                {data.name}
                            </NameText>
                        </ToSummonerLink>
                    </MarginBox>
                </FlexBox>
                <FlexBox justifyContent={'center'} height={'17px'}>
                    <LeftGreenText/>
                    <RunCardGreenText>
                        남은 LP
                    </RunCardGreenText>
                    <RightGreenText/>
                </FlexBox>
                <GamesText>
                    {data.matches} Games
                </GamesText>
                <FlexBox justifyContent={'center'} margin={'8px 0 0 0'}>
                    <img src={`images/sll/icon_flame.svg`} alt={''} width={24} height={24}/>
                    <SllTierRunCardBigText>
                        <span>{data.need_lp}</span>
                        <LPText>LP</LPText>
                    </SllTierRunCardBigText>
                </FlexBox>
                <FlexBox margin={'9px 0 0 0'}>
                    <TierRunCardRelativeBox>
                        <img src={`images/sll/img_sll_tier_run_graph_wrapper.svg`} alt={''} width={184} height={12}/>
                        <TierRunCardAbsoluteBox>
                            <TierRunCardCircleRelativeBox>
                                <SllTierRunGraphSvg value={graphValue} place={place}/>
                                <CircleAbsoluteBox value={graphValue}>
                                    <TierRunCardCircleBox>
                                        <EmblemImage width={16} height={16} tier={data.current_tier}/>
                                    </TierRunCardCircleBox>
                                </CircleAbsoluteBox>
                            </TierRunCardCircleRelativeBox>
                        </TierRunCardAbsoluteBox>
                    </TierRunCardRelativeBox>
                </FlexBox>
                <TierRunCardBar/>
                <CardInfoBox>
                    <FlexBox height={'auto'}>
                        <CardInfoTierBox>
                            <CardInfoGreenText>
                                CURRENT
                            </CardInfoGreenText>
                            <FlexBox height={'auto'} justifyContent={'center'}>
                                <TierTag
                                    division={currentSplitTier.division}
                                    tier={currentSplitTier.tier}
                                />
                                <LpText>
                                    {data.current_lp}
                                </LpText>
                                <LpGrayText>
                                    LP
                                </LpGrayText>
                            </FlexBox>
                        </CardInfoTierBox>
                        <MarginBox margin={'0 7px'}>
                            <img src={`images/sll/img_sll_tier_fast.svg`} alt={''} width={19} height={12}/>
                        </MarginBox>
                        <CardInfoTierBox>
                            <CardInfoGreenText>
                                GOAL
                            </CardInfoGreenText>
                            <FlexBox height={'auto'} justifyContent={'center'}>
                                <TierTag
                                    division={goalSplitTier.division}
                                    tier={goalSplitTier.tier}
                                />
                                <LpText>
                                    {data.goal_lp}
                                </LpText>
                                <LpGrayText>
                                    LP
                                </LpGrayText>
                            </FlexBox>
                        </CardInfoTierBox>
                    </FlexBox>
                    <LpBar/>
                    <FlexBox height={'auto'} justifyContent={'space-between'}>
                        <FlexBox height={'auto'}>
                            <CardWinText>
                                승률
                            </CardWinText>
                            <WinRateText>
                                {(data.win_per * 100).toFixed(1)}
                                <PercentText>
                                    %
                                </PercentText>
                            </WinRateText>
                        </FlexBox>
                        <FlexBox height={'auto'}>
                            <AiText>
                                AI-Score
                            </AiText>
                            <GradientScoreBox fontSize={'16px'} width={'40px'} height={'24px'} borderRadius={'4px'}>
                                {data.ai_score}
                            </GradientScoreBox>
                        </FlexBox>
                    </FlexBox>
                </CardInfoBox>
            </div>
        </SllTierRunCardWrapper>
    )
}

const CategoryText = styled.span`
  font-family: Pretendard;
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
  text-transform: uppercase;
  color: ${props => props.theme.color.dark_100};
`;
const SllTierRunCategory = ({selected, setCategory, value}) => {
    const isSelected = selected === value
    return (
        <SelectorItemWrapper selected={isSelected} onClick={() => setCategory(value)} value={value}>
            <SelectedGreenBar value={value}/>
            <CategoryText>
                {value}
            </CategoryText>
            {isSelected && <AbsoluteBox/>}
        </SelectorItemWrapper>
    )
}

const FinishedTime = ({timeStamp}) => {
    const time = useMemo(() => {
        if (!timeStamp) {
            return 0;
        }
        const finishedTime = new Date(timeStamp * 1000);

        const year = finishedTime.getFullYear();
        const month = finishedTime.getMonth() + 1;
        const date = finishedTime.getDate()

        const hour = finishedTime.getHours().toString();
        const min = finishedTime.getMinutes().toString();
        const second = finishedTime.getSeconds().toString();


        return `${year}-${month < 10 ? '0' + month : month}-${date < 10 ? '0' + date : date} ${hour}:${min}:${second}`

    }, [timeStamp])

    return time
}

export default SllTierRunInfo;